/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveCustomerRequest = {
  /**
   * The unique identifier of the customer.
   */
  customerId?: string | undefined;
  /**
   * The email address of the customer.
   */
  email?: string | undefined;
};

/** @internal */
export const RetrieveCustomerRequest$inboundSchema: z.ZodType<
  RetrieveCustomerRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  customer_id: z.string().optional(),
  email: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "customer_id": "customerId",
  });
});
/** @internal */
export type RetrieveCustomerRequest$Outbound = {
  customer_id?: string | undefined;
  email?: string | undefined;
};

/** @internal */
export const RetrieveCustomerRequest$outboundSchema: z.ZodType<
  RetrieveCustomerRequest$Outbound,
  z.ZodTypeDef,
  RetrieveCustomerRequest
> = z.object({
  customerId: z.string().optional(),
  email: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    customerId: "customer_id",
  });
});

export function retrieveCustomerRequestToJSON(
  retrieveCustomerRequest: RetrieveCustomerRequest,
): string {
  return JSON.stringify(
    RetrieveCustomerRequest$outboundSchema.parse(retrieveCustomerRequest),
  );
}
export function retrieveCustomerRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveCustomerRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveCustomerRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveCustomerRequest' from JSON`,
  );
}
